// extracted by mini-css-extract-plugin
export default {"pageContainer":"SelectClassPage_pageContainer__uTNad"};